<template>
  <app-page :title="title" :icon="icon" :class="cssClass">
    <template #header>
      <div class="d-flex align-items-center">
        <divisions-dropdown v-if="showDivisionsDropdown" />
        <b-button
          v-if="portalUpdatesJan2026Enabled"
          variant="primary"
          :class="showDivisionsDropdown ? 'ml-3' : ''"
          :disabled="isGenerating || !canDownloadComputed"
          title="Download PDF"
          @click="handleDownload"
        >
          <b-spinner v-if="isGenerating" small />
          <font-awesome-icon v-else :icon="['fad', 'download']" class="mr-2" />Download PDF
        </b-button>
      </div>
    </template>
    <template #custom-content>
      <b-col ref="contentRef">
        <analytics-nav />
        <slot />
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import { computed, ref } from 'vue';
import AppPage from '@/components/AppPage.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import useSubsectionDownload from '@/composables/useSubsectionDownload';
import AnalyticsNav from '@/pages/analyticsHomepage/components/AnalyticsNav.vue';
import DivisionsDropdown from '@/pages/analyticsHomepage/components/DivisionsDropdown.vue';

const props = defineProps({
  title: { type: String, required: true },
  icon: { type: String, required: true },
  cssClass: { type: String, default: '' },
  defaultLabel: { type: String, required: true },
  showDivisionsDropdown: { type: Boolean, default: true },
  inlineKpis: { type: Boolean, default: true },
  canDownload: { type: Function, default: null },
  getSheetConfig: { type: Function, default: null },
});

const contentRef = ref(null);
const { portalUpdatesJan2026Enabled } = useFeatureFlags();
const { isGenerating, downloadSheet } = useSubsectionDownload();

const canDownloadComputed = computed(() => (props.canDownload ? props.canDownload() : true));

async function handleDownload() {
  await downloadSheet({
    label: props.defaultLabel,
    getContainerEl: () => contentRef.value?.$el || contentRef.value,
    inlineKpis: props.inlineKpis,
    getPdfData: props.getSheetConfig || undefined,
  });
}
</script>
